module.exports = __webpack_public_path__ + "img/mobile-banner2.259799bd.png";